import { openErrorToast } from '@pct-ng/feature-message-material';
import type { TranslateAbleText } from '@pct-ng/i18n';

export function openFormErrorToast(title: TranslateAbleText): void {
  openErrorToast({
    title,
    message: 'PAGES.COMMON.DETAILS.TOASTER_MESSAGES.FORM_ERROR',
  });
}
